"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCollectionName = void 0;
var getCountryIdFromWarehouseId_1 = require("./getCountryIdFromWarehouseId");
function getCollectionName(params) {
    var countryId = params.countryId;
    if (!countryId) {
        countryId = getCountryIdFromWarehouseId_1.getCountryIdFromWarehouseId(params.warehouseId, params.isThrowingError);
    }
    countryId = countryId === "uk" ? "gb" : countryId || getCountryIdFromWarehouseId_1.DEFAULT_COUNTRY_ID;
    return countryId + "_" + params.collection;
}
exports.getCollectionName = getCollectionName;
